module.exports = __webpack_public_path__ + "img/7.f3a0c600.png";